<template>
    <v-expansion-panels>
        <v-expansion-panel class="rounded-xl">
            <v-expansion-panel-header class="rounded-xl" color="#6499faff" style="color: white;">
                {{ $t('form.note') }}
                <span v-if="note.createdAt" class="ml-1"> ({{ getNoteDate(note.createdAt) }}) :</span>
                <span v-if="note.note" class="ml-1"> {{ shortText(note.note, 80) }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content color="grey lighten-4 rounded-b-xl">
                <div class="d-flex justify-end my-2">
                    <v-btn small color="primary" @click="printComponent">
                        <v-icon>mdi-printer</v-icon>
                        {{ $t('button.print') }}
                    </v-btn>
                </div>
                <div ref="printArea">
                    <v-form>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="note.note"
                                    :label="`${$t('form.note')} ${note.createdAt ? `- ${getNoteDate(note.createdAt)}` : ''}`"
                                    clearable
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'NoteForm',
        props: {
            note: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => {
            return {
            }
        },
        computed: {
        },
        watch: {
        },
        created() {
        },
        methods: {
            getNoteDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            shortText(text, max = 80) {
                if (!text) return ''
                const trimmed = String(text)
                if (trimmed.length <= max) return trimmed
                return trimmed.slice(0, max - 3) + '...'
            },
            printComponent() {
                // Print only the v-model content (note.note) in a minimal popup
                const noteText = this.note && this.note.note ? String(this.note.note) : ''

                // Simple HTML-escape
                const escapeHtml = (s) => s
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')

                const escaped = escapeHtml(noteText)

                // Use white-space: pre-wrap so newlines are preserved
                const contentHtml = `<div style="white-space: pre-wrap; font-family: Roboto, Arial, sans-serif; font-size:14px;">${escaped}</div>`

                // Collect stylesheet links and inline styles (keeps app styles available)
                const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(l => l.outerHTML).join('\n')
                const styles = Array.from(document.querySelectorAll('style')).map(s => s.outerHTML).join('\n')

                const html = `
                    <html>
                        <head>
                            <title>Print Note</title>
                            ${links}
                            ${styles}
                            <style>
                                body { margin: 0; padding: 20px; }
                            </style>
                        </head>
                        <body onload="setTimeout(function(){ window.print(); window.close(); }, 100)">
                            ${contentHtml}
                        </body>
                    </html>`

                const win = window.open('', '_blank', 'width=900,height=700')
                if (!win) {
                    if (typeof this.setAlert === 'function') {
                        this.setAlert('Popup blocked. Please allow popups to print.', 'error')
                    } else {
                        alert('Popup blocked. Please allow popups to print.')
                    }
                    return
                }

                win.document.open()
                win.document.write(html)
                win.document.close()
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
